import { motion } from 'motion/react';
import type { WorkOption } from '../types';

interface EducationsShapesProps {
  step?: 1 | 2 | 3;
  selectedWorkOption: WorkOption | null;
}

export function EducationsShapes({
  step = 1,
  selectedWorkOption,
}: EducationsShapesProps): JSX.Element {
  const getContainerStyle = () => {
    if (step === 3) {
      return { transform: 'translate(-130px, 230px) scale(1)', opacity: 1 };
    }
    if (step === 2 && selectedWorkOption !== null) {
      return { transform: 'translate(-200px, -150px) scale(0.9)', opacity: 0.4 };
    }
    return undefined;
  };

  return (
    <div
      className="absolute left-[300px] top-[300px] transition-all duration-1000"
      style={getContainerStyle()}
    >
      <motion.div
        initial={{ opacity: 0, rotate: 90, scale: 0.5 }}
        animate={{ opacity: 1, rotate: 0, scale: 1 }}
        exit={{ opacity: 0, rotate: -180, scale: 0.5 }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
      >
        <svg
          width="210"
          height="210"
          viewBox="0 0 210 210"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_9861_2275)">
            <mask
              id="mask0_9861_2275"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="210"
              height="210"
            >
              <path d="M209.694 0H0V209.694H209.694V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_9861_2275)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M209.694 52.4235V4.58301e-06L104.847 0V52.4028C104.836 23.4596 81.3693 4.58301e-06 52.4235 4.58301e-06H2.2915e-06V104.847H52.4235C23.4708 104.847 -1.26557e-06 128.318 0 157.271L2.2915e-06 209.694H104.847V157.271C104.847 186.223 128.318 209.694 157.271 209.694H209.694V104.847H157.291C186.234 104.836 209.694 81.3693 209.694 52.4235Z"
                fill="#FF938B"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_9861_2275">
              <rect width="209.694" height="209.694" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </motion.div>
      <motion.div
        className="absolute left-[175px] top-[80px]"
        initial={{ opacity: 0, translateX: 30 }}
        animate={{ opacity: 1, translateX: 0 }}
        exit={{ opacity: 0, translateX: 30 }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
      >
        <svg
          width="244"
          height="244"
          viewBox="0 0 244 244"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_9861_2293)">
            <mask
              id="mask0_9861_2293"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="244"
              height="244"
            >
              <path d="M243.772 0H0V243.772H243.772V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_9861_2293)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M53.6298 0H0V182.829C0 216.487 27.2851 243.772 60.943 243.772H114.573V60.943C114.573 27.2851 87.2877 0 53.6298 0ZM190.142 0C156.485 0 129.199 27.2851 129.199 60.943V243.772H182.829C216.487 243.772 243.772 216.487 243.772 182.829V0H190.142Z"
                fill="#988BFF"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_9861_2293">
              <rect width="243.772" height="243.772" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </motion.div>
    </div>
  );
}
